import "./camera.css";

import React, { useState, useEffect, useCallback } from "react";
import { Surface } from "gl-react-dom";
import { Normalize } from "./Normalize";
import { Video } from "./Video";
import { Camera } from "./Camera";
import { Controls } from "./Controls";
import { useWindowSize } from "react-use";

export const PrimaryScreen = () => {
  const screen = useWindowSize();
  const [options, setOptions] = useState({ intensity: 1, daltonism: 0 });

  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  const handleRatio = useCallback(
    ({ width, height }) => {
      if (width > screen.width) {
        const ratio = screen.width / width;
        width = screen.width;
        height = height * ratio;
      }

      const dim = { width, height };

      if (dim.width !== dimensions.width) {
        setDimensions(dim);
      }
    },
    [screen, setDimensions, dimensions]
  );

  const handleOnVideo = useCallback(
    video => {
      let width = video.naturalWidth || video.videoWidth;
      let height = video.naturalHeight || video.videoHeight;

      handleRatio({ width, height });
    },
    [handleRatio]
  );

  useEffect(() => handleRatio(dimensions), [dimensions, handleRatio]);

  return (
    <div className="page">
      <div style={{ textAlign: "center" }}>
        <Surface {...dimensions}>
          <Normalize {...options}>
            {redraw => (
              <Video onVideo={handleOnVideo} onFrame={redraw} autoPlay>
                <Camera></Camera>
              </Video>
            )}
          </Normalize>
        </Surface>
      </div>
      {Boolean(dimensions.width) && (
        <Controls videoWidth={dimensions.width} onSelect={setOptions} />
      )}
    </div>
  );
};
